let instance = null;
export default class LayerStyleStore {
  constructor() {
    if (instance) {
      return instance;
    }
    this.point = {
      singleSymbol: null,
      uniqueValue: null,
      gradulSymbol: null
    };
    this.line = {
      singleSymbol: null,
      uniqueValue: null,
      gradualSymbol: null
    };
    this.polygon = {
      singleSymbol: null,
      uniqueValue: null,
      gradualSymbol: null
    }
    this.pointStyle = null;
    this.lineStyle = null;
    this.polygonStyle = null;
    this.style = null;
    this.pointUniqueValueBuffer = new ElementsArrayBuffer();
    this.pointGradualSymbolBuffer = new ElementsArrayBuffer();
    this.lineUniqueValueBuffer = new ElementsArrayBuffer();
    this.lineGradualSymbolBuffer = new ElementsArrayBuffer();
    this.polygonUniqueValueBuffer = new ElementsArrayBuffer();
    this.polygonGradualSymbolBuffer = new ElementsArrayBuffer();
    instance = this;
  }

  clear() {
    this.style = null;
    this.clearPointStyles();
    this.clearLineStyles();
    this.clearPolygonStyles();
  }

  clearPointStyles() {
    this.point = {
      singleSymbol: null,
      uniqueValue: null,
      gradulSymbol: null
    };
    this.pointStyle = null;
    this.pointUniqueValueBuffer.clear();
    this.pointGradualSymbolBuffer.clear();
  }

  clearLineStyles() {
    this.line = {
      singleSymbol: null,
      uniqueValue: null,
      gradulSymbol: null
    };
    this.lineStyle = null;
    this.lineUniqueValueBuffer.clear();
    this.lineGradualSymbolBuffer.clear();
  }

  clearPolygonStyles() {
    this.polygon = {
      singleSymbol: null,
      uniqueValue: null,
      gradulSymbol: null
    };
    this.polygonStyle = null;
    this.polygonUniqueValueBuffer.clear();
    this.polygonGradualSymbolBuffer.clear();
  }

  getStyle() {
    return this.style;
  }

  getPointStyle() {
    return this.pointStyle;
  }

  getLineStyle() {
    return this.lineStyle;
  }

  getPolygonStyle() {
    return this.polygonStyle;
  }

  getPointSingleSymbol() {
    return this.point.singleSymbol;
  }

  getPointUniqueValue() {
    return this.point.uniqueValue;
  }

  getPointUniqueValueBuffer() {
    return this.pointUniqueValueBuffer;
  }

  getPointGradualSymbol() {
    return this.point.gradulSymbol;
  }

  getPointGradulSymbolBuffer() {
    return this.pointGradualSymbolBuffer;
  }

  getLineSingleSymbol() {
    return this.line.singleSymbol;
  }

  getLineUniqueValue() {
    return this.line.uniqueValue;
  }

  getLineUniqueValueBuffer() {
    return this.lineUniqueValueBuffer;
  }

  getLineGradualSymbol() {
    return this.line.gradulSymbol;
  }

  getLineGradulSymbolBuffer() {
    return this.lineGradualSymbolBuffer;
  }

  getPolygonSingleSymbol() {
    return this.polygon.singleSymbol;
  }

  getPolygonUniqueValue() {
    return this.polygon.uniqueValue;
  }

  getPolygonUniqueValueBuffer() {
    return this.polygonUniqueValueBuffer;
  }

  getPolygonGradualSymbol() {
    return this.polygon.gradulSymbol;
  }

  getPolygonGradulSymbolBuffer() {
    return this.polygonGradualSymbolBuffer;
  }

  setStyle(value) {
    this.style = JSON.parse(JSON.stringify(value));
  }

  setPointStyle(value) {
    this.pointStyle = JSON.parse(JSON.stringify(value));
  }

  setLineStyle(value) {
    this.lineStyle = JSON.parse(JSON.stringify(value));
  }

  setPolygonStyle(value) {
    this.polygonStyle = JSON.parse(JSON.stringify(value));
  }

  setPointSingleSymbol(value) {
    this.point.singleSymbol = JSON.parse(JSON.stringify(value));
  }

  setPointUniqueValue(value) {
    this.point.uniqueValue = JSON.parse(JSON.stringify(value));
  }

  setPointUniqueValueBuffer(value) {
    this.pointUniqueValueBuffer.set(value);
  }

  setPointGradualSymbol(value) {
    this.point.gradulSymbol = JSON.parse(JSON.stringify(value));
  }

  setPointGradualSymbolBuffer(value) {
    this.pointGradualSymbolBuffer.set(value);
  }

  setLineSingleSymbol(value) {
    this.line.singleSymbol = JSON.parse(JSON.stringify(value));
  }

  setLineUniqueValue(value) {
    this.line.uniqueValue = JSON.parse(JSON.stringify(value));
  }

  setLineUniqueValueBuffer(value) {
    this.lineUniqueValueBuffer.set(value);
  }

  setLineGradualSymbol(value) {
    this.line.gradulSymbol = JSON.parse(JSON.stringify(value));
  }

  setLineGradualSymbolBuffer(value) {
    this.lineUniqueValueBuffer.set(value);
  }

  setPolygonSingleSymbol(value) {
    this.polygon.singleSymbol = JSON.parse(JSON.stringify(value));
  }

  setPolygonUniqueValue(value) {
    this.polygon.uniqueValue = JSON.parse(JSON.stringify(value));
  }

  setPolygonUniqueValueBuffer(value) {
    this.polygonUniqueValueBuffer.set(value);
  }

  setPolygonGradualSymbol(value) {
    this.polygon.gradulSymbol = JSON.parse(JSON.stringify(value));
  }

  setPolygonGradualSymbolBuffer(value) {
    this.polygonGradualSymbolBuffer.set(value);
  }
}

class ElementsArrayBuffer {
  constructor() {
    this.items = [];
  }

  any() {
    return this.items.length;
  }

  clear() {
    this.items = [];
  }

  count() {
    return this.items.length;
  }

  get(index, elements) {
    if (index !== undefined) {
      if (elements !== undefined) {
        return this.items.slice(index, elements);
      } else {
        return this.items[index];
      }
    }
    return this.items;
  }

  push(item) {
    this.items.push(JSON.parse(JSON.stringify(item)));
  }

  remove(item) {
    const index = this.items.indexOf(item);
    if (index > -1) {
      this.items.splice(index, 1);
    }
  }

  set(value, index) {
    if (index !== undefined) {
      this.items[index] = JSON.parse(JSON.stringify(value));
    } else {
      this.items = JSON.parse(JSON.stringify(value));
    }
  }
}